import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'gob-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {
  
  private _max: number = 0;
  private _activePage: number = 0;
  public isChanging: boolean = false;

  @Input() 
  set max(val: number) {
    this._max = typeof val === 'string' ? parseInt(val, 10) : val;
    this.isChanging = false;
  }
  get max(): number {
    return this._max;
  }
  
  @Input() 
  set activePage(val: number) {
    this._activePage = typeof val === 'string' ? parseInt(val, 10) : val;
  }
  get activePage(): number {
    return this._activePage;
  }

  @Output() readonly change: EventEmitter<number> = new EventEmitter<number>();

  constructor() { }

  ngOnInit(): void { }

  loadMore() {
    if (this.activePage < this.max - 1) {
      this.isChanging = true; 
      this.change.emit(this.activePage + 1);

      setTimeout(() => {
        this.isChanging = false;
      }, 800);
    }
  }

  isEnd(): boolean {
    if (this.isChanging) return false;
    return this.max > 0 && this.activePage >= this.max - 1;
  }
}